import React from 'react';
import SearchFilterBtn from '../../../../components/buttons/SearchFilterBtn';
import SearchFor from '../../../Modals/SearchFor';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import HeadTittle from '../../../../components/HeadTittle';
import PayrollFunctionality from './Functionality/FunctionalityPayroll';
import StepTab from "../../../../components/StepperTabs/StepTab";
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import AttendanceTable from "./Subcomponents/AttendanceTable";
import {TAB_PERMISSION_ATTENDANCE, TABS_ATTENDANCE} from "./Model/Model";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import {
    AddIcon, EditIcon,
    TrashOutlineIcon,
} from "../../../../components/buttons/IconButtons";
import ManageTab from './Manage/ManageTab';
import OvertimePoliciesTab from './OvertimePolicies/OvertimePoliciesTab';
import PayrollTab from './PayrollTab/PayrollTab';
import {permissionObj} from '../../../../Helpers/permission';
import routes from '../../../../Routes/routes';
import { ATTENDANCE_MODES } from '../../Dining/Manage/Models/Model';
import SubmissionTab from "./Submission/SubmissionTab";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Payroll = () => {

    const {
        searchElement,
        setSearchElement,
        option,
        selectedOption,
        setSimpleSearch,
        setSearch,
        contractorId,
        supplierId,
        search,
        setSendSimpleSearch,
        searchClean,
        criteria,
        setCriteria,
        filterDialogShow,
        setSelectedOption,
        finalArray,
        moduleId,
        subView,
        activeStep,
        setActiveStep,
        steps,
        setFilterDialogShow,
        setFinalArray,
        handleStepChange,
        view,
        setView,
        render,
        setRender,
        permissionButtons,
        handleUpdate,
        bodyForExport,
        setBodyForExport,
        changeSubViewManage,
        goCreate,
        selectForDelete, setSelectForDelete,
        registerAction,
        handleDelete,
        modified,
        setModified,
        handleView,
        DEV,
        permission,
        navigate,
        selectedList,
        setSelectedList,
        actionsRef,
        canReviewUpdates,
        handleReviewUpdates,
        isAllChecked,
        setIsAllChecked,
        subViewChild,
        setSubViewChild,
        handleAssign,
        isAttendanceSupervisor,
        exportReady,
        setExportReady
    } = PayrollFunctionality();

    if (!DEV &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SETTING_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_MANAGE_GEOFENCES_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_REQUEST_READ) &&
        !permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_HISTORY_READ) &&
        !permission?.includes(permissionObj?.WEB_USER_SPECIAL_PERMISSION_READ) &&
        !permission?.includes(permissionObj?.WEB_PAYROLL_POLICY_READ) &&
        !permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_READ) &&
        !permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_USER_READ) &&
        !permission?.includes(permissionObj?.WEB_PAYROLL_ACTIVE_READ) &&
        !permission?.includes(permissionObj?.WEB_PAYROLL_HISTORY_READ) &&
        !isAttendanceSupervisor //Used for attendance department supervisor, for can manage attendees, slice loaded in login action
    ) {
        navigate(routes.forbidden);
    }

    return (
        <>
            <HeadTittle name={'attendance'}>
                {permissionButtons(TAB_PERMISSION_ATTENDANCE({ subView, view, exportReady }).EXPORT) && (
                    <>
                        {activeStep === TABS_ATTENDANCE.PAYROLL.INDEX ? (
                            <ExportDataBtn
                                id="btn_p_export"
                                moduleId={moduleId}
                                option={option}
                                search={false}
                                searchElement={searchElement}
                                body={bodyForExport}
                                contractorSupplier={false}
                            />
                        ) : search ? (
                            <ExportDataBtn
                                id="btn_p_export"
                                moduleId={moduleId}
                                search={search}
                                option={option}
                                exportAttendance={criteria}
                            />
                        ) : (
                            <ExportDataBtn
                                id="btn_p_export"
                                moduleId={moduleId}
                                option={option}
                                search={search}
                                searchElement={searchElement}
                                body={bodyForExport}
                                exportAttendance={bodyForExport}
                            />
                        )}
                    </>
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE({subView, view}).ADVANCE_SEARCH) && (
                    <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE({subView, view, subViewChild}).CREATE) && (
                    <ButtonAction
                        id='btn_pa_create'
                        name='create'
                        className='btn-icon-add'
                        disabled={false}
                        Icon={AddIcon}
                        onClick={() => {
                            goCreate();
                        }}
                    />
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE({subView, view, subViewChild}).UPDATE) && (
                    <ButtonAction
                        id='btn_pa_update'
                        name='update'
                        className='btn-icon-add'
                        disabled={false}
                        Icon={EditIcon}
                        onClick={()=>{
                            handleUpdate();
                        }}
                    />
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE({subView, view, subViewChild}).ASSIGN) && (
                    <ButtonAction
                        id='btn_pa_assign'
                        name='assign'
                        className='btn-icon-add'
                        disabled={!actionsRef.current?.[subView]?.handleAssign}
                        Icon={EditIcon}
                        onClick={()=>{
                            handleAssign();
                        }}
                    />
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE({subView, view, subViewChild}).DELETE) && (
                    <ButtonAction
                        id='btn_pa_delete'
                        name='delete'
                        className='btn-icon-delete'
                        Icon={TrashOutlineIcon}
                        disabled={selectForDelete?.length === 0}
                        onClick={() => {
                            handleDelete();
                        }}
                    />
                )}

                {permissionButtons(TAB_PERMISSION_ATTENDANCE({
                    subView,
                    view,
                    subViewChild
                }).REVIEW_UPDATES) &&
                    canReviewUpdates() &&
                        <ButtonAction
                            id='btn_pa_review_updates'
                            name='review_updates'
                            className='btn-icon-add'
                            splitName={false}
                            disabled={!actionsRef.current?.[subView]?.handleReviewUpdates }
                            onClick={() => {
                                handleReviewUpdates();
                            }}
                        />
                }
            </HeadTittle>

            <StepperTabs
                id={null}
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab normalHeight={true} index={TABS_ATTENDANCE.ATTENDANCE.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.ATTENDANCE.INDEX && (
                        <AttendanceTable
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            option={option}
                            selectedOption={selectedOption}
                            setSimpleSearch={setSimpleSearch}
                            setSearch={setSearch}
                            contractorId={contractorId}
                            supplierId={supplierId}
                            search={search}
                            setSendSimpleSearch={setSendSimpleSearch}
                            searchClean={searchClean}
                            setCriteria={setCriteria}
                            setSelectedOption={setSelectedOption}
                            finalArray={finalArray}
                            setFinalArray={setFinalArray}
                            view={view}
                            setView={setView}
                            render={render}
                            setRender={setRender}
                            activeStep={activeStep}
                            modified={modified}
                            setModified={setModified}
                            handleView={handleView}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_ATTENDANCE.SUBMISSIONS.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.SUBMISSIONS.INDEX && (
                        <SubmissionTab
                            subView={subView}
                            changeSubViewManage={changeSubViewManage}
                            registerAction={registerAction}
                            option={option}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                            setBodyForExport={setBodyForExport}
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            modified={modified}
                            setModified={setModified}
                            activeStep={activeStep}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_ATTENDANCE.MANAGE.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.MANAGE.INDEX && (
                        <ManageTab
                            subView={subView}
                            changeSubViewManage={changeSubViewManage}
                            registerAction={registerAction}
                            option={option}
                            selectForDelete={selectForDelete}
                            setSelectForDelete={setSelectForDelete}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                            modified={modified}
                            setModified={setModified}
                            isAllChecked={isAllChecked}
                            setIsAllChecked={setIsAllChecked}
                            subViewChild={subViewChild}
                            setSubViewChild={setSubViewChild}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_ATTENDANCE.OVERTIME_POLICIES.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.OVERTIME_POLICIES.INDEX && (
                        <OvertimePoliciesTab
                            subView={subView}
                            changeSubViewManage={changeSubViewManage}
                            registerAction={registerAction}
                            option={option}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                            modified={modified}
                            setModified={setModified}
                            activeStep={activeStep}
                            selectForDelete={selectForDelete}
                            setSelectForDelete={setSelectForDelete}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_ATTENDANCE.PAYROLL.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_ATTENDANCE.PAYROLL.INDEX && (
                        <PayrollTab
                            subView={subView}
                            changeSubView={changeSubViewManage}
                            option={option}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                            modified={modified}
                            setModified={setModified}
                            activeStep={activeStep}
                            registerAction={registerAction}
                            setExportReady={setExportReady}
                        />
                    )}
                </StepTab>
            </StepperTabs>

            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFinalArray(originalArray);
                        setFilterDialogShow(false);
                        setSearchElement('');// Clear search input after filtering
                        setSelectedOption(ATTENDANCE_MODES.daily);
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    search={search}
                    setSearch={setSearch}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    setFinalArray={setFinalArray} // Used to reset filters
                    searchElement={searchElement} // Track input changes
                />
            }
        </>
    );
};

export default Payroll;
